import MainPageLayout from 'layouts/MainPageLayout';
import { FormattedMessage } from 'react-intl';
import Organizer from './Organize/Organizer';

const Organize = (): JSX.Element => {
  return (
    <MainPageLayout title={<FormattedMessage id="organize_page.title" />}>
      <Organizer />
    </MainPageLayout>
  );
};

export default Organize;
